import { get, find, isBoolean, isNumber, isEmpty } from 'lodash';

import { serializeContactName, serializeManagerName } from './general';
import { getCallURLById, getOrderURLById } from '../../utils/parsers';

import { TYPES as PERSON_TYPES } from '../../consts/persons';

export const parseCall = (unparsedCall, sideload) => {
  const { isSupervisor, unparsedOrders, unparsedPersons, unparsedReasons } =
    sideload;

  const callId = get(unparsedCall, 'id');
  const finishedAt = get(unparsedCall, 'finished_at', null);
  const reasonsIds = get(unparsedCall, 'call_reason_ids');
  const reasons = reasonsIds
    ? reasonsIds.map(id => {
        const unparsedReason = find(unparsedReasons, { id });
        const type = get(unparsedReason, 'kind');
        if (!type) {
          return null;
        }

        return {
          description: get(unparsedReason, 'subkind'),
          id,
          reasonId: get(unparsedReason, 'reason_id'),
          type,
        };
      })
    : null;
  const recordUrl = get(unparsedCall, 'record_url', null);
  const isAnswered = get(unparsedCall, 'is_answered', null);
  const unparsedIsIncoming = get(unparsedCall, 'is_incoming');
  const isIncoming = isBoolean(unparsedIsIncoming) ? unparsedIsIncoming : null;
  const call = {
    answeredAt: get(unparsedCall, 'answered_at', null),
    callUrl: getCallURLById(callId),
    finishedAt,
    id: callId ? String(callId) : null,
    pbxId: get(unparsedCall, 'pbx_id', null),
    isActive: isNumber(finishedAt) ? false : !recordUrl,
    isAnswered,
    isCallback: get(unparsedCall, 'is_callback') || false,
    isIncoming,
    isListen: false,
    reasons,
    startedAt: get(unparsedCall, 'started_at', null),
  };

  // Contact.
  const contactId = get(unparsedCall, 'person_id');
  const contactType = get(unparsedCall, 'person_type') || PERSON_TYPES.CLIENT; // Если тип неизвестен, то считаем, что это новый клиент.
  const unparsedContact = find(unparsedPersons, {
    person_id: contactId,
    person_type: contactType,
  });
  const phone = get(unparsedCall, 'person_phone');
  const avatarUrl = get(unparsedContact, 'avatar_url');
  const contact = {
    avatarUrl:
      avatarUrl !== 'client_auth/default_avatar@2x.jpg' ? avatarUrl : null, // TODO: Fix on backend
    email: get(unparsedContact, 'email') || '', // It's for client card.
    fullName: serializeContactName(
      get(unparsedContact, 'full_name'),
      phone,
      contactType
    ),
    id: contactId ? String(contactId) : null,
    isNew: !!get(unparsedContact, 'is_new'),
    isSegmentAllowed: get(unparsedContact, 'is_segment_allowed') || null,
    name: get(unparsedContact, 'name') || null, // It's for client card.
    phone, // It's for new client in client card.
    partner: get(unparsedCall, 'partner', null),
    surname: get(unparsedContact, 'surname') || null, // It's for client card.
    type: contactType, // It's for logic of opening client card.
  };

  // Operator.
  const unparsedOperatorId = get(unparsedCall, 'manager_id');
  const operatorId = unparsedOperatorId ? String(unparsedOperatorId) : null;
  const unparsedOperator = find(unparsedPersons, {
    person_id: +operatorId,
    person_type: 'manager',
  });
  const operator = {
    name: serializeManagerName(
      'call',
      operatorId,
      get(unparsedOperator, 'full_name'),
      isIncoming
    ),
    number: get(unparsedOperator, 'sip_extension'),
  };

  // Order.
  const orderId = get(unparsedCall, 'order_id');
  let order = null;
  if (orderId) {
    const unparsedOrder = find(unparsedOrders, { id: orderId });
    order = {
      href: getOrderURLById(orderId),
      id: String(orderId),
      status: get(unparsedOrder, 'state'),
    };
  }

  // Supervisor.
  const isSupervisorInCall =
    get(unparsedOperator, 'sip_supervisor') ||
    get(unparsedContact, 'sip_supervisor');
  call.isListenable = isSupervisor && !isSupervisorInCall && isAnswered;
  call.recordUrl = !isSupervisorInCall && recordUrl;

  // TODO: Need to add parsing of ticket data.

  return {
    call,
    contact,
    operator,
    order,
  };
};

export const parseCalls = (unparsedData, isSupervisor) => {
  const {
    call_reasons: unparsedReasons,
    calls: unparsedCalls,
    orders: unparsedOrders,
    persons: unparsedPersons,
  } = unparsedData;

  if (isEmpty(unparsedCalls)) {
    return [];
  }

  return unparsedCalls.map(unparsedCall =>
    parseCall(unparsedCall, {
      isSupervisor,
      unparsedOrders,
      unparsedPersons,
      unparsedReasons,
    })
  );
};

export const parseContactInfo = data => {
  const { client: unparsedContact, orders: unparsedOrders } = data;

  const id = get(unparsedContact, 'person_id');
  const number = get(unparsedContact, 'phone');
  // Если тип неизвестен, то считаем, что это новый клиент.
  const personType = get(unparsedContact, 'person_type') || PERSON_TYPES.CLIENT;
  const contact = {
    email: get(unparsedContact, 'email') || '',
    fullName: serializeContactName(
      get(unparsedContact, 'full_name'),
      number,
      personType
    ),
    id: (id && String(id)) || null,
    isNew: !!get(unparsedContact, 'is_new'),
    isSegmentAllowed: get(unparsedContact, 'is_segments_allowed') || null,
    name: get(unparsedContact, 'name') || null,
    number,
    surname: get(unparsedContact, 'surname') || null,
    type: personType,
  };

  const orderId = get(unparsedContact, 'order_id');
  if (orderId) {
    const unparsedOrder = find(unparsedOrders, { id: orderId });
    contact.order = {
      href: getOrderURLById(orderId),
      id: String(orderId),
      status: get(unparsedOrder, 'state_en'),
    };
  }

  return contact;
};
